export default "__VITE_ASSET__eff66d3b__"